import {browserHistory} from 'react-router';
import * as settings from 'settings/settings';

export function redirectTo(){
    var urlSearch = new URLSearchParams (window.location.search);
    var redirectTo = urlSearch.get("redirect");

    if(redirectTo)
    {
        if(redirectTo.lastIndexOf(settings.baseName) === -1)
        {
            /*
                non contiene il base name , lo devo aggiungere
            */
           if(redirectTo === "/")
           {
                redirectTo = settings.baseName;
           }
           else{
                redirectTo = settings.baseName + redirectTo;
           }

        }
        console.log('redirecting to ' + redirectTo);
        browserHistory.push(redirectTo);
    }
    else{
        browserHistory.push(settings.baseName);
    }
}

export function redirectToLogin(){
    browserHistory.push(settings.baseName + 'login');
}


// WEBPACK FOOTER //
// ./src/services/url/redirectServices.js